import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import { b as getHydrationData, d as _createForOfIteratorHelper } from '../../dist/utils-4b9185c7.esm.js';
export { i as attachHydrationData, e as eraseHydrationData, b as getHydrationData } from '../../dist/utils-4b9185c7.esm.js';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import '@babel/runtime/helpers/toConsumableArray';

function getNames(data) {
  var componentsMap = {};
  Object.keys(data).map(function (key) {
    var comp = data[key];

    if (comp !== null && comp !== void 0 && comp.name) {
      componentsMap[comp.name] = true;
    }
  });
  return componentsMap;
}

function getChunks() {
  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var data = getHydrationData();
  var componentsToHydrate = getNames(data);
  var chunks = [];

  if (Object.keys(componentsToHydrate).length === 0) {
    return chunks;
  }

  var _iterator = _createForOfIteratorHelper(components),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _name = _step.value;

      if (componentsToHydrate[_name]) {
        chunks.push(_name);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return chunks;
}

function hydrateComponents(_x) {
  return _hydrateComponents.apply(this, arguments);
}

function _hydrateComponents() {
  _hydrateComponents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(components) {
    var themeChunk,
        names,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            themeChunk = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      return _context.abrupt("return", {
                        "default": {}
                      });

                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));
            names = Object.keys(components).map(function (key) {
              return key;
            });
            window.rehydrate = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var chunksArr, _yield$Promise$all, _yield$Promise$all2, themeModule, _yield$Promise$all2$, hydrate, _getHydrationData, _getHydrationData2, _getHydrationData2$th, themeOptions, theme;

              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      chunksArr = getChunks(names);

                      if (!(chunksArr.length > 0)) {
                        _context2.next = 13;
                        break;
                      }

                      _context2.next = 4;
                      return Promise.all([themeChunk(), import(
                      /* webpackChunkName: "partial-hydration" */
                      '../../hydrate/dist/xsite-ui-partial-hydration-hydrate.esm.js')]);

                    case 4:
                      _yield$Promise$all = _context2.sent;
                      _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                      themeModule = _yield$Promise$all2[0];
                      _yield$Promise$all2$ = _yield$Promise$all2[1];
                      hydrate = _yield$Promise$all2$["default"];
                      _getHydrationData = _yield$Promise$all2$.getHydrationData;
                      _getHydrationData2 = _getHydrationData(), _getHydrationData2$th = _getHydrationData2.themeOptions, themeOptions = _getHydrationData2$th === void 0 ? {} : _getHydrationData2$th;
                      theme = typeof themeModule["default"] === 'function' ? themeModule === null || themeModule === void 0 ? void 0 : themeModule["default"](themeOptions) : themeModule === null || themeModule === void 0 ? void 0 : themeModule["default"];
                      chunksArr.map(function (name) {
                        return components[name]().then(function (module) {
                          hydrate([module["default"]], {
                            theme: theme
                          });
                        })["catch"](function (error) {
                          console.log(error);
                        });
                      });

                    case 13:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));
            window.rehydrate();

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _hydrateComponents.apply(this, arguments);
}

export { getChunks as default, hydrateComponents };
